import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { switchMap } from 'rxjs';
import { ApiModule } from '../../api-client/openapi/api.module';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authenticationInterceptor } from './services/authentication/authentication.interceptor';
import { AuthenticationService } from './services/authentication/authentication.service';
import { AuthorizationService } from './services/authorization/authorization.service';

import '@progress/kendo-angular-intl/locales/de/all';
import '@progress/kendo-angular-intl/locales/en/all';
import { uploadInterceptor } from './shared/upload.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21 defaults to zoneless; this app still relies on zone-driven change detection.
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(
      ApiModule.forRoot({
        rootUrl: environment.baseApiUrl,
      })
    ),
    provideHttpClient(
      withInterceptors([authenticationInterceptor, uploadInterceptor])
    ),
    provideAppInitializer(() => {
      const authenticationService = inject(AuthenticationService);
      const authorizationService = inject(AuthorizationService);

      return authenticationService
        .init()
        .pipe(switchMap(() => authorizationService.updateRoles()));
    }),
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/xi18n/',
        suffix: '.json',
      }),
    }),
    {
      provide: LOCALE_ID,
      useValue: 'en-all',
    },
  ],
};
